import React, { HTMLAttributeAnchorTarget } from 'react'
import { Button, ButtonProps, Space } from 'antd'
import { Link } from 'react-router'
import { ExportOutlined } from '@ant-design/icons'

type LinkButtonProps = {
  href: string
  value: React.ReactNode
  type?: ButtonProps['type']
  target?: HTMLAttributeAnchorTarget | undefined;
  showIcon?: boolean
}

export const LinkButton: React.FC<LinkButtonProps> = ({ href, value, type, target, showIcon }) => {
  return (
    <Space>
      <Link to={href} target={target}>
        <Button icon={showIcon ? <ExportOutlined /> : null} type={type || 'link'} htmlType="button">
          {value}
        </Button>
      </Link>
    </Space>
  )
}